<template>
  <div class="tax-loader" data-testid="income-tax-calculator-loader">
    <SkeletonLoader class="tax-loader__header">
      <div class="tax-loader__header__icon" />
      <div class="tax-loader__header__title" />
      <div class="tax-loader__header__description" />
    </SkeletonLoader>
    <ContentDisplayLoader
      v-for="index in 2"
      :key="index"
      class="tax-loader__card"
    >
      <SkeletonLoader>
        <div class="tax-loader__card__title" />
        <div
          v-for="descriptionIndex in 3"
          :key="descriptionIndex"
          :style="{ width: descriptionIndex === 3 ? '90%' : '100%' }"
          class="tax-loader__card__description"
        />
      </SkeletonLoader>
    </ContentDisplayLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: { ContentDisplayLoader, SkeletonLoader }
})
export default class TaxCalculatorLoader extends Vue {}
</script>

<style lang="less" scoped>
.tax-loader {
  max-width: 592px;
  box-sizing: content-box;
  padding-left: @size-spacing-x500;
  padding-right: @size-spacing-x500;
  margin: 0 auto;

  &__header {
    margin-top: @size-spacing-x700;
    margin-bottom: @size-spacing-x900;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__icon {
      width: 64px;
      height: 64px;
      border-radius: @size-radius-max;
      margin-bottom: @size-spacing-x500;
    }

    &__title {
      height: 48px;
      width: 85%;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x400;
    }

    &__description {
      height: 56px;
      width: 100%;
      border-radius: @size-radius-x100;
    }
  }

  &__card {
    margin-bottom: @size-spacing-x500;

    &__title {
      height: 28px;
      width: 75%;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x400;
    }

    &__description {
      height: 24px;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x75;
    }
  }
}
</style>
